<panel width="auto">
	<nav mat-stretch-tabs="false" mat-tab-nav-bar mat-align-tabs="left" [tabPanel]="tabPanel" dropdown-parent (onDropdownClosed)="visibleDropdown = undefined">
		@for (shortcut of shortcuts; track shortcut) {
			<tooltip [text]="shortcut.description | translate" [showDelay]="200" [disabled]="!!shortcut.children" (dropdown-trigger)="visibleDropdown = shortcut">
				<a mat-tab-link (click)="shortcut.action && activeLink = shortcut; shortcut.clickAction()" [disableRipple]="!shortcut.action" [active]="activeLink == shortcut">
					@if (shortcut.icon) { <icon small clickable [type]="shortcut.icon" /> }
					<span>{{ shortcut.name | translate }}</span>
					@if (shortcut.children) { <icon small clickable [type]="visibleDropdown == shortcut ? 'chevron-up' : 'chevron-down'" /> }
				</a>
				@let parent = shortcut;
				@if (shortcut.children) {
					<dropdown-menu class="dropdown-menu mat-elevation-z4">
						@for (shortcut of shortcut.children; track shortcut) {
							<menu-item [disabled]="!shortcut.action" (action)="activeLink = parent; shortcut.clickAction()">
								@if (shortcut.icon) { <icon small clickable [type]="shortcut.icon" /> }
								<span>{{ shortcut.name | translate }}</span>
							</menu-item>
							}
					</dropdown-menu>
					}
			</tooltip>
		}
	</nav>
	<mat-tab-nav-panel #tabPanel />
</panel>
